import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { sans as zoram, lineHeight, fontSize13, fontWeightBold, fontWeightNormal } from "@churchofjesuschrist/eden-style-constants";
import shared from "./shared";
const Container5 = styled.div.withConfig({
  componentId: "sc-1wnkqiv-0"
})(["font-family:", ";font-weight:", ";line-height:", ";font-size:", ";", ";& b,& strong{font-weight:", ";}"], zoram, fontWeightNormal, lineHeight, fontSize13, shared, fontWeightBold);

const Text5 = ({
  children,
  ...props
}) => /*#__PURE__*/React.createElement(Container5, props, children);

Text5.propTypes = {
  /** Content */
  children: PropTypes.node.isRequired
};
export default Text5;